export const createLink = ({
  url,
  pathname,
  searchParams,
}: {
  url: string;
  pathname?: string;
  searchParams?: Record<string, string>;
}): string => {
  // Create URL from string
  const link = new URL(url);

  if (pathname) {
    link.pathname = pathname;
  }

  // Add or update searchParams
  if (searchParams) {
    Object.entries(searchParams).forEach(([key, value]) => {
      if (link.searchParams.has(key)) {
        link.searchParams.set(key, value);
      } else {
        link.searchParams.append(key, value);
      }
    });
  }

  return link.toString();
};
